module.exports = __webpack_public_path__ + "/7e3f488cef3f5af01c1ae7e3dc7b3495.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/handshake_icon.svg
 ** module id = 1527
 ** module chunks = 0
 **/